<script setup lang="ts">
import { useEmployeeStore } from '@/stores/employee';
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();
const employeeStore = useEmployeeStore();
const jwtToken = ref<string>(route.params.token as string);

onMounted(async () => {
    if (jwtToken.value) {
        await employeeStore.verifyChangeEmail(jwtToken.value);
    }

    await router.push('/');
});
</script>

<template>
    <div></div>
</template>
